// Google Material Icon: person with money (beneficial owner)
export interface IIconProps {
	color?: string;
	size?: number;
}

export const IconPersonMoney = ({ color = "currentColor", size = 24 }: IIconProps) => {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-7 9v-2c0-2.21 3.13-4 7-4v-1.5c-1.5 0-2.91.38-4.09 1.04C6.72 15.53 5 17.49 5 19v2H3v-2c0-2.66 5.33-4 8-4h2c.35 0 .69.02 1.03.05"
				fill={color}
			/>
			<path
				d="M16.5 12c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5h2v1h-2.5v1h2v1.5h1V17h.5c.28 0 .5-.22.5-.5v-1c0-.28-.22-.5-.5-.5h-2v-1h2.5v-1h-2V12h-1z"
				fill={color}
			/>
		</svg>
	);
};
